import * as constants from "./constants";

const initialState = {
  loading: false,
  reportBatches: [],
  error: null,
};

const reportBatchesReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case constants.FETCH_REPORT_BATCHES:
      return { ...state, loading: true, error: null };

    case constants.FETCH_REPORT_BATCHES_SUCCESS:
      return { ...state, loading: false, reportBatches: action.payload };

    case constants.FETCH_REPORT_BATCHES_ERROR:
      return { ...state, loading: false, error: "Failed to fetch report batches" };

    
    case constants.UPDATE_REPORT_BATCHES:
      return { ...state, loading: true };

    case constants.UPDATE_REPORT_BATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        reportBatches: state.reportBatches.map((batch) =>
          batch._id === action.payload._id ? action.payload : batch
        ),
      };

    case constants.UPDATE_REPORT_BATCHES_ERROR:
      return { ...state, loading: false, error: "Failed to update report batch" };

    case constants.DELETE_REPORT_BATCHES:
      return { ...state, loading: true };

    case constants.DELETE_REPORT_BATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        reportBatches: state.reportBatches.filter((batch) => batch._id !== action.id),
      };

    case constants.DELETE_REPORT_BATCHES_ERROR:
      return { ...state, loading: false, error: "Failed to delete report batch" };

    default:
      return state;
  }
};

export default reportBatchesReducer;
